import './styles.scss';
import React, { useState, useEffect } from 'react';
import AttendanceService from '../../services/AttendanceService';
import EventService from '../../services/EventService';
import DateUtils from '../../../../services/DateUtils';
import AdminService from '../../services/AdminService';
import { __, STR_KEY } from '../../../../services/Translate';

const Header = ({ account, event, ignore_account_branding}) => {
    let [remainingTime, setRemainingTime] = useState({total: 0});

    useEffect(() => {

        const checkinHasStarted = EventService.checkinHasStarted(event);
        const endDateTimeUtc    = event.end_datetime_utc;

        if (!checkinHasStarted || !endDateTimeUtc) return;

        let remainingTime = getTimeRemaining(endDateTimeUtc);

        // Set the initial counter value (on state)
        setRemainingTime(remainingTime);

        // Recalculate counter value every second
        let coundownInterval = setInterval(() => {
            remainingTime = getTimeRemaining(endDateTimeUtc);
            // Update counter value (on state)
            setRemainingTime(remainingTime);

            // Clear interval after the event has finished
            if (remainingTime.total <= 0) clearInterval(coundownInterval);
        }, 1000);

        // Clear the interval when component unmounts
        return () => clearInterval(coundownInterval);
    }, [event]);

    const logo = account.header_logo || 'images/default-logo.png';
    const brandingColor = account.color && !ignore_account_branding ? account.color : '#FFFFFF';
    const colorDescriptor = getColorDescriptor(brandingColor);

    const countdownTime = () => {
        if (remainingTime.total <= 0) {
            return <p className="event-finished">{__(STR_KEY.VIDEO_HEADER_DESCRIPTION_FINISHED)}</p>
        }
        return <CountdownClock 
            endTime={remainingTime} 
            colorDescriptor={colorDescriptor} 
        />
    }

    return (
        <div className="header-container d-flex align-items-center" style={{ backgroundColor: brandingColor }}>
             <div className="header-logo">
                {!ignore_account_branding ? (
                    <img src={logo} alt="" />
                ) : null}
            </div>
            <div className="header-controls-container d-flex">
                {EventService.checkinHasStarted(event) ? countdownTime() : null}
                <LeaveEventBtn colorDescriptor={colorDescriptor} />
            </div>
        </div>
    );
};

export const getColorDescriptor = (hexcolor) => {
  if (!hexcolor) return "light";

  const cleanHex = hexcolor.startsWith("#") ? hexcolor.slice(1) : hexcolor;
  const [r, g, b] = [0, 2, 4].map((start) =>
    parseInt(cleanHex.substr(start, 2), 16)
  );

  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 128 ? "light" : "dark";
};

export const LeaveEventBtn = ({ colorDescriptor }) => {
    if (!AdminService.isAdmin()) {
        return (
            <div className={`header-control d-flex align-items-center ${colorDescriptor}`}>
                { AttendanceService.renderRsvpPageLink(__(STR_KEY.VIDEO_HEADER_BTN_LEAVE), 'fa-power-off') }
            </div>      
        );
    }
    return null;
}

export const getTimeRemaining = (endtime) => {
    const total = endtime - DateUtils.utcNow();
    const seconds = Math.floor(total % 60);
    const minutes = Math.floor((total / 60) % 60);
    const hours = Math.floor((total / (60 * 60)) % 24);
    const days = Math.floor(total / (60 * 60 * 24));

    return {
        total,
        days,
        hours,
        minutes,
        seconds
    };
}

export const CountdownClock = ({ endTime, colorDescriptor }) => {
    let timeRemaining;

    if (endTime.days > 0) {
        timeRemaining = `${endTime.days}d ${endTime.hours}h`;
    } else if (endTime.days === 0 && endTime.hours > 0) {
        timeRemaining = `${endTime.hours}h ${endTime.minutes}m ${endTime.seconds}s`;
    } else if (endTime.days === 0 && endTime.hours === 0 && endTime.minutes > 0 || endTime.seconds > 0) {
        timeRemaining = `${endTime.minutes}m ${endTime.seconds}s`;
    }

    return (
        <div className={`countdown-timer-container d-flex flex-column text-right ${colorDescriptor}`}>
            <p className="time-remaining">{__(STR_KEY.VIDEO_HEADER_DESCRIPTION_TIME)}</p>
            <p className="time">{timeRemaining}</p>
        </div> 
    );
}

export default Header;
